const firebaseConfig = {
  apiKey: "AIzaSyCpOAvX9Es1BauxCQETeA41NDGe2ggbq5o",
  authDomain: "speech-bubbles.firebaseapp.com",
  databaseURL: "https://speech-bubbles.firebaseio.com",
  projectId: "speech-bubbles",
  storageBucket: "speech-bubbles.appspot.com",
  messagingSenderId: "687185015707",
  appId: "1:687185015707:web:c1352d7ad574b187"
};

export default firebaseConfig;